export enum Currency {
	USD = 'USD',
	RUB = 'RUB',
	EUR = 'EUR',
	SAR = 'SAR',
	KZT = 'KZT',
	AED = 'AED',
	AMD = 'AMD',
	UZS = 'UZS',
	AZN = 'AZN',
	TRY = 'TRY',
	RSD = 'RSD',
	GEL = 'GEL',
	ILS = 'ILS',
	CNY = 'CNY',
	BYN = 'BYN',
	GBP = 'GBP',
	TJS = 'TJS'
}

export enum CurrencySymbols {
	USD = '$',
	RUB = '₽',
	EUR = '€',
	SAR = '﷼',
	AED = 'د.إ',
	AMD = '֏',
	UZS = 'UZS',
	AZN = '₼',
	TRY = '₺',
	RSD = 'din',
	GEL = '₾',
	ILS = '₪',
	KZT = '₸',
	CNY = '¥',
	BYN = '\ue901',
	TJS = 'C.',
	GBP = '£'
}

export enum PassengerType {
	Adult = 'ADT',
	Teenager = 'PDA', // WZ only
	Teenager_F7 = 'YTH',
	Retiree_F7 = 'SRC',
	Child = 'CLD',
	ChildCNN = 'CNN',
	Teenager_GCF = 'GCF',
	Infant = 'INF',
	InfantWithSeat = 'INS',
	InfantWithSeat_RVT = 'РВТ', // Y7 only
	YoungAdult = 'МЛА',
	RetireeM = 'SCM',
	RetireeF = 'SCF',
	Adult_D2 = 'ААА',
	Child_D2 = 'РБГ',
	Infant_D2 = 'РМГ',
	InfantWithSeat_D2 = 'РВГ',
	Retiree_D2 = 'ЦПА',
	AdultWithChild_D2 = 'PDA',
	Family_D2 = 'PFA',
	Teenager_D2 = 'WAB'
}

export interface ModifyPassenger {
	passengerType: PassengerType;
	modifyCount?: number;
}
